import { render, staticRenderFns } from "./TopSerchMain.vue?vue&type=template&id=21f8403f"
import script from "./TopSerchMain.vue?vue&type=script&lang=js"
export * from "./TopSerchMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports